module.exports = __webpack_public_path__ + "img/antes_despues_217.5d2bc7b6.png";